(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('AccountManagementController', AccountManagementController);

  /** @ngInject */
  function AccountManagementController(
    $scope,
    AccountManagementViewModel,
    userActions,
    $mdDialog,
    $translate,
    $state,
    $timeout,
    isValidUser,
    reportActions
  ) {
    var vm = this;
    var counter = 0;
    var companyId = null;

    vm.accountManagement = new AccountManagementViewModel();

    init();

    function init() {
      // If not valid user redirect to home page
      if (!isValidUser) {
        $state.go('app.dashboardTechnology');
      }
      $scope.$on('destroy', function () {});
      refreshUsers();
    }

    function refreshUsers() {
      vm.promise = userActions
        .getOrganizationUsers(
          vm.accountManagement.filterUsers,
          vm.accountManagement.currentPage - 1,
          vm.accountManagement.limitPerPage,
          vm.accountManagement.orderBy,
          vm.accountManagement.order
        )
        .then(function (data) {
          vm.accountManagement.refresh(data);
        });
    }

    vm.deleteUser = function (ev, userId, organizationId, email) {
      var confirm = $mdDialog
        .confirm()
        .title($translate.instant('ARE_YOU_SURE'))
        .textContent(
          $translate.instant('ALL_INFORMATION_1') +
            ' ' +
            email +
            ' ' +
            $translate.instant('ALL_INFORMATION_2')
        )
        .ariaLabel('delete user')
        .targetEvent(ev)
        .ok($translate.instant('YES'))
        .cancel($translate.instant('CANCEL'));

      $mdDialog.show(confirm).then(function () {
        userActions
          .deleteOrganizationUser(userId, organizationId)
          .then(function () {
            refreshUsers();
          });
      });
    };

    vm.pageChanged = function (page, limit) {
      vm.accountManagement.paginationChanged(page, limit);
      refreshUsers();
    };

    vm.deleteHistory = function (ev) {
      userActions.getCompanyDetails().then(function (res) {
        companyId = res.id;

        var confirm = $mdDialog
          .confirm()
          .title($translate.instant('DELETE_COMPANY_HISTORY'))
          .content($translate.instant('DELETE_COMPANY_HISTORY_CONFIRMATION'))
          .ariaLabel('delete history confirmation dialog')
          .targetEvent(ev)
          .ok($translate.instant('DELETE'))
          .cancel($translate.instant('CANCEL'));

        $mdDialog.show(confirm).then(function () {
          reportActions.deleteReportsData(companyId).then(
            function () {
              vm.historyDeletedMsg = true;
            },
            function () {
              vm.historyDeletedErrorMsg = true;
            }
          );
        });
      });
    };

    vm.addNewUser = function () {
      $state.go('app.accountManagement.user');
    };

    vm.updateListOfUsers = function () {
      $timeout(function () {
        counter += 1;
        if (counter === 1) {
          refreshUsers();
        }
      }, 1200);
      counter = 0;
    };

    vm.resendVerificationMail = function (user) {
      userActions.resendVerificationMail(user.email).then(function () {});
    };
  }
})();
